import { Avatars } from 'assets/avatars'
import { AccountsLayout } from '../components/layout'
import { BsTrash, BsUpload } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import { InputField } from 'cwp-components/forms'
import { useForm } from 'react-hook-form'

const LawFirmCreationDetails = () => {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    trigger,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  const onSubmit = () => {
    navigate('/accounts/law-firm/manager')
  }
  return (
    <AccountsLayout>
      <div className='relative space-y-[48px] md:w-[900px] !m-auto md:p-[60px] bg-white rounded-[20px] shadow-[-0.8px_-0.8px_16px_0px_rgba(0,0,0,0.25)]'>
        <div className='flex justify-between'>
          <h1 className='md:text-[24px] font-bold'>Profile creation</h1>
          <span className='md:text-[16px] text-[#3E75BC]'>
            Law firm's details
          </span>
        </div>
        <div className='flex justify-between'>
          <div className='flex items-center md:gap-[17px]'>
            <img className='w-[80px] h-[80px]' src={Avatars._Dummy} alt='' />
            <div className='space-y-[6px] text-[#001A3D]'>
              <p>
                <BsUpload className='inline' /> Upload law firm's logo
              </p>
              <p>
                <BsTrash className='inline' /> Delete
              </p>
            </div>
          </div>
        </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className='grid md:grid-cols-2 gap-[50px]'
        >
          <div className='flex flex-col item-center space-y-[12px]'>
            <InputField
              register={register}
              id='firmName'
              label={`Law firm's name`}
              placeholder={`firmName`}
              value={'Complement label'}
              className='!h-[44px]'
              labelSize='10px'
              disabled
            />
            <InputField
              register={register}
              id='sraID'
              label='SRA ID'
              className='!h-[44px]'
              placeholder='sraID'
              required={true}
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />

            <InputField
              register={register}
              required={true}
              id='email'
              label='Email address'
              placeholder='email'
              className='!h-[44px]'
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />
            <InputField
              register={register}
              required={true}
              id='phoneNumber'
              label='Phone number'
              placeholder='phoneNumber'
              className='!h-[44px]'
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />
            <InputField
              register={register}
              required={true}
              id='companyRegNumber'
              label='Company reg. number'
              placeholder='companyRegNumber'
              className='!h-[44px]'
              errors={errors}
              labelSize='10px'
              errorMessage='This field is mandatory. Please enter the requested information.'
            />
            <div className='flex items-center gap-[12px]'>
              <InputField
                register={register}
                required={true}
                id='hourlyRate'
                label='Hourly rate (£)'
                placeholder='hourlyRate'
                className='!h-[44px]'
                errors={errors}
                labelSize='10px'
                errorMessage='This field is mandatory. Please enter the requested information.'
              />

              <div className='text-[#6E7785] flex items-center text-[14px] gap-[6px]'>
                <input type='checkbox' name='' id='' /> Includes VAT
              </div>
            </div>
          </div>
          <div className='flex flex-col item-center space-y-[12px]'>
            <InputField
              register={register}
              id='sraEntityId'
              label='SRA entity ID'
              value={'123456'}
              placeholder='sraEntityId'
              className='!h-[44px]'
              labelSize='10px'
              disabled
            />
            <InputField
              register={register}
              id='sraStatus'
              label='SRA status'
              value={'Complement label'}
              placeholder='sraStatus'
              className='!h-[44px]'
              labelSize='10px'
              disabled
            />
            <InputField
              register={register}
              id='admissionPeriod'
              label='Admission period'
              value={'Complement label'}
              placeholder='admissionPeriod'
              className='!h-[44px]'
              labelSize='10px'
              disabled
            />
            <InputField
              register={register}
              id='admissionDate'
              label='Admission date'
              value={'07/05/2024'}
              placeholder='admissionDate'
              className='!h-[44px]'
              labelSize='10px'
              disabled
            />
            <InputField
              register={register}
              id='postCode'
              label='Postcode'
              placeholder='postCode'
              className='!h-[44px]'
              labelSize='10px'
              value={'Complement label'}
              disabled
            />
          </div>
          <div className='flex col-span-2 justify-end'>
            <button
              // onClick={handleSubmit}
              className={`btn btn-default`}
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </AccountsLayout>
  )
}

export default LawFirmCreationDetails
